module.exports = __webpack_public_path__ + "static/atelierfranck66-344edc634f007dee0401f4a6c2bfd17d.jpg";